import { referenceOfMeta } from '../init';

export function normalizeProductFamilyIconUrl(url?: string | null) {
  if (!url) {
    return url;
  }
  return url.startsWith('http')
    ? url
    : `${referenceOfMeta._envConfig?.assets.vs ?? ''}${url.startsWith('/') ? url : `/${url}`}`;
}
